import { useContext } from 'react'
import { AuthenticationContext } from './AuthenticationContext'

export const useAuthenticationContext = () => useContext(AuthenticationContext)
